"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _excluded = ["className", "active", "tooltip"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Button(_ref, ref) {
  var className = _ref.className,
    active = _ref.active,
    tooltip = _ref.tooltip,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    tabIndex: "-1"
  }, props, {
    ref: ref,
    type: "button",
    className: (0, _classnames["default"])(className, 'inline-flex  items-center p-1 border border-transparent focus:border-ultra-light rounded text-sm select-none     focus:bg-secondary hover:bg-secondary', {
      'text-primary': active,
      'hover:text-primary-active': active,
      'focus:text-primary-active': active,
      'bg-secondary': active,
      'text-gray-light': props.disabled
    })
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(Button);
//# sourceMappingURL=Button.js.map